const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_perks_info_lightbox',
    modelClass: require('./model'),
    viewClass: require('./view'),
    options: {
        '*': {
            showMoreMembershipPriceRange: Odigeo.Membership.showMoreMembershipPriceRange,
            isMyAccountPage: false,
            isResultsPage: false,
            isPaymentPage: false,
        },
        'membership-perks-info-lightbox-results': {
            isResultsPage: true,
        },
        'membership-perks-info-lightbox-my-account-page': {
            isMyAccountPage: true,
        },
        'membership-perks-info-lightbox-payment': {
            isPaymentPage: true,
        },
    },
    methods: {
        openMembershipPerksInfoLightbox(data) {
            this.openMembershipPerksInfoLightbox(data);
        },
        closeMembershipPerksInfoLightbox() {
            this.closeMembershipPerksInfoLightbox();
        },
        resetMembershipPerksInfoLightbox() {
            this.resetMembershipPerksInfoLightbox();
        },
        loginDone() {
            this.model.loginDone();
        },
        logoutDone() {
            this.model.logoutDone();
        },
    },
});
